<template>
  <div class="service-features">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-8 service-features__intro typography">
          <h2>{{ data.introduction_title }}</h2>
          <p class="large">{{ data.introduction_subtitle }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6 service-features__list">
          <ul>
            <li
              v-for="(feature, index) in data.features"
              v-bind:key="'feature' + index"
              :class="active_feature_index == index ? `active` : ``"
            >
              <a
                href="#"
                v-on:click.prevent="set_active_feature($event, index)"
              >
                <inline-svg
                  src="/app/themes/redbeemedia/images/chevron-white-right.svg"
                ></inline-svg>
                <span v-html="feature.title"></span>
              </a>
            </li>
          </ul>
        </div>
        <div
          class="col-12 col-md-6 service-features__detail"
          id="service-features-detail"
        >
          <div
            class="service-features__detail__pointer"
            :style="{ top: get_pointer_position + 'px' }"
          ></div>
          <div
            class="service-features__detail__inner typography"
            v-html="active_feature.description"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isMobile } from "mobile-device-detect";

export default {
  name: "ServiceFeatures",
  data: function() {
    return {
      data: window.service_details,
      active_feature_index: 0,
      pointer_position: 0,
      pointer_position_offset: 15
    };
  },
  methods: {
    set_active_feature(event, index) {
      this.active_feature_index = index;
      // get the position of the arrow
      let triggerPosition = event.target.offsetTop;
      this.pointer_position = triggerPosition;

      var options = {
        easing: "ease-in",
        offset: -100,
        force: true,
        cancelable: true,
        x: false,
        y: true
      };

      if (isMobile) {
        this.$scrollTo("#service-features-detail", 500, options);
      }
    }
  },
  computed: {
    active_feature() {
      return this.data.features[this.active_feature_index];
    },
    get_pointer_position() {
      return this.pointer_position + this.pointer_position_offset;
    }
  }
};
</script>

<style lang="scss">
.service-features {
  padding-bottom: 64px;

  @media screen and (max-width: 767px) {
    padding-bottom: 17px;
  }

  &__intro {
    margin-bottom: 32px;
    p.large {
      font-weight: normal;
    }
  }

  @media screen and (max-width: 767px) {
    margin-bottom: 17px;
  }

  &__list {
    padding-right: 32px;

    @media screen and (max-width: 767px) {
      padding-right: 16px;
    }

    ul {
      border-top: 1px solid rgba(255, 255, 255, 0.3);
      li {
        border-bottom: 1px solid rgba(255, 255, 255, 0.3);
        transition: all 0.3s ease-in-out;

        &.active,
        &:focus,
        &:hover {
          background-color: white;
          a {
            color: #dc281e;

            svg {
              path {
                fill: #dc281e;
              }
            }
          }
        }

        a {
          color: white;
          text-transform: uppercase;
          font-size: 16px;
          font-weight: 600;
          display: flex;
          align-items: center;
          margin-bottom: 0;
          padding: 14px 20px;

          svg {
            transform: rotate(180deg);
            margin-right: 10px;
            width: 9px;
            height: 6px;
          }
        }
      }
    }
  }

  &__detail {
    position: relative;

    @media screen and (max-width: 767px) {
      margin-top: 32px;
    }

    &__pointer {
      width: 21px;
      height: 21px;
      transform: rotate(45deg);
      background-color: white;
      position: absolute;
      left: 5px;
      transition: top 0.2s ease-in-out;

      @media screen and (max-width: 767px) {
        display: none;
      }
    }
    &__inner {
      background-color: white;
      padding: 24px;
      height: 100%;

      &.typography {
        ul {
          margin: 0 0 0 24px;
        }
        p,
        ul li {
          color: #3c505a;
          font-size: 20px;
          line-height: 26px;
          font-weight: 300;
        }
      }
    }
  }
}
</style>
